var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinalChapter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40003245_42525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75 3.21875C7.0625 3.5 7.0625 3.96875 6.78125 4.28125L4.53125 6.78125C4.40625 6.90625 4.21875 7 4 7C3.8125 7.03125 3.59375 6.9375 3.46875 6.78125L2.21875 5.53125C1.90625 5.25 1.90625 4.78125 2.21875 4.46875C2.5 4.1875 2.96875 4.1875 3.25 4.46875L3.96875 5.1875L5.6875 3.25C5.96875 2.9375 6.4375 2.9375 6.75 3.21875ZM6.75 8.21875C7.0625 8.5 7.0625 8.96875 6.78125 9.28125L4.53125 11.7812C4.40625 11.9062 4.21875 12 4 12C3.8125 12.0312 3.59375 11.9375 3.46875 11.7812L2.21875 10.5312C1.90625 10.25 1.90625 9.78125 2.21875 9.5C2.5 9.1875 2.96875 9.1875 3.25 9.5L3.96875 10.1875L5.6875 8.25C5.96875 7.96875 6.4375 7.9375 6.75 8.21875ZM9 5C9 4.46875 9.4375 4 10 4H17C17.5312 4 18 4.46875 18 5C18 5.5625 17.5312 6 17 6H10C9.4375 6 9 5.5625 9 5ZM9 10C9 9.46875 9.4375 9 10 9H17C17.5312 9 18 9.46875 18 10C18 10.5625 17.5312 11 17 11H10C9.4375 11 9 10.5625 9 10ZM7 15C7 14.4688 7.4375 14 8 14H17C17.5312 14 18 14.4688 18 15C18 15.5625 17.5312 16 17 16H8C7.4375 16 7 15.5625 7 15ZM3.5 13.5C4.03125 13.5 4.5 13.8125 4.78125 14.25C5.0625 14.7188 5.0625 15.3125 4.78125 15.75C4.5 16.2188 4.03125 16.5 3.5 16.5C2.9375 16.5 2.46875 16.2188 2.1875 15.75C1.90625 15.3125 1.90625 14.7188 2.1875 14.25C2.46875 13.8125 2.9375 13.5 3.5 13.5Z",
    fill: "url(#paint0_linear_40003245_42525)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_40003245_42525",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB9B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4545"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40003245_42525"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalChapter);
export default __webpack_public_path__ + "static/media/finalChapter.67b90b627938556e172d501c749f5d3a.svg";
export { ForwardRef as ReactComponent };